var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4999 20.8962C22.4999 21.5058 22.0056 22 21.3961 22H3.60382C2.99406 22 2.5 21.5058 2.5 20.8962V3.10382C2.5 2.49414 2.99406 2 3.60382 2H21.3961C22.0056 2 22.4999 2.49414 22.4999 3.10382V20.8962ZM16.2963 14.2477V21.9927H13.1793V14.2477H10.5729V11.2293H13.1793V9.0033C13.1793 6.42003 14.757 5.01339 17.0615 5.01339C18.1652 5.01339 19.114 5.09558 19.3905 5.13238V7.83198L17.7922 7.83268C16.539 7.83268 16.2963 8.42822 16.2963 9.30213V11.2293H19.2852L18.896 14.2477H16.2963Z",
    fill: "#395185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.14bff41afd4d7989ffb99626ac1105fb.svg";
export { ForwardRef as ReactComponent };